import "./navbar.css";
import { useState } from "react";
import LogoBlanco from "../../assets/logo/LogoBlanco.png";
import { useMediaQuery } from "react-responsive";
import { Modal, Button, Typography } from "antd";
import FormClienteModal from "../modals/FormClienteModal";
import FormMarcaModal from "../modals/FormMarcaModal";
import FormVisitaModal from "../modals/FormVisitaModal";
import { PRIMARY_COLOR } from "../../shared/colors";

const Navbar = () => {
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { Title, Text } = Typography;

  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [clienteOpen, setClienteOpen] = useState(false);
  const [marcaOpen, setMarcaOpen] = useState(false);
  const [visitaOpen, setVisitaOpen] = useState(false);

  const openCliente = () => {
    setContactModalOpen(false);
    setClienteOpen(true);
  };
  const openMarca = () => {
    setContactModalOpen(false);
    setMarcaOpen(true);
  };
  const openVisita = () => {
    setContactModalOpen(false);
    setVisitaOpen(true);
  };

  return (
    <div className="navbar">
      <div className="navbar-container">
        <div className="logo">
          <a href="/" className="text-decoration-none text-white">
            <img
              style={{ width: "130px", height: "auto" }}
              src={LogoBlanco}
              alt="Logo Stock Distribuciones"
            />
          </a>
        </div>

        {isMobile ? (
          <>
            <button
              className={`hamburger ${drawerOpen ? "active" : ""}`}
              onClick={() => setDrawerOpen(!drawerOpen)}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            <div className={`mobile-menu ${drawerOpen ? "active" : ""}`}>
              <button
                className="mobile-menu-item"
                type="button"
                onClick={() => {
                  setContactModalOpen(true);
                  setDrawerOpen(false);
                }}
              >
                Contacto
              </button>
            </div>
          </>
        ) : (
          <div className="menu-navbar">
            <button
              className="menu-navbar-item-button"
              type="button"
              onClick={() => setContactModalOpen(true)}
            >
              Contacto
            </button>
          </div>
        )}
      </div>

      <Modal
        open={contactModalOpen}
        onCancel={() => setContactModalOpen(false)}
        footer={null}
        centered
        className="custom-modal"
        style={{ top: 20 }}
        styles={{
          body: {
            maxHeight: 'calc(90vh - 200px)',
            overflowY: 'auto',
            paddingBottom: '24px'
          },
          mask: {
            backgroundColor: 'rgba(0, 0, 0, 0.45)'
          },
        }}
        title={
          <div style={{ textAlign: 'center', margin: "20px 0" }}>
            <Title level={4} style={{ margin: 0, fontFamily: "Poppins", color: PRIMARY_COLOR, fontSize: "20px" }}>
              ¿Cómo querés contactarnos?
            </Title>
            <Text type="secondary" style={{ fontFamily: "Poppins" }}>
              Seleccioná una opción para continuar
            </Text>
          </div>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 20, padding: "15px" }}>
          <Button className="btn-option-contact" onClick={openCliente} block>
            Quiero ser cliente
          </Button>
          <Button className="btn-option-contact" onClick={openMarca} block>
            Quiero sumar mi marca
          </Button>
          <Button className="btn-option-contact" onClick={openVisita} block>
            Quiero que me visiten
          </Button>
        </div>
      </Modal>

      <FormClienteModal isOpen={clienteOpen} setIsOpen={setClienteOpen} />
      <FormMarcaModal isOpen={marcaOpen} setIsOpen={setMarcaOpen} />
      <FormVisitaModal isOpen={visitaOpen} setIsOpen={setVisitaOpen} />
    </div>
  );
};

export default Navbar;
